import React, { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { LuxurySlider } from "../Luxury"
import { sliderBanner, sliderItemClick } from "../../../actions/slidersAction";
import { getAllBrands } from "../../../actions/filterAction"
import { getCloudImageUrl } from "../../../utils/Helpers"
import LuxuryBrandImageHeader from "../../../images/brand-page-header.jpg"
import { Container } from "reactstrap"
import { Banner } from "../../../Container/Assets"
import { RESOURCE_URL } from "../../../config"

function LuxuryBrandPage({ brandData, getAllBrands, history, match, sliderBanner }) {

  const [activeSlide, setActiveSlide] = useState(0)
  const [pause, setPause] = useState(false)
  const [sliderUrl, setSliderUrl] = useState(`${RESOURCE_URL}assets-image/brand-luxury-${window.screen.availWidth <= 480 ? "portrait" : "landscape"}.jpg`)

  useEffect(() => {
    window.scrollTo(0, 0)
    if (match.params.category !== "luxury") {
      history.replace("/404")
    } else {
      _getSliderBanner()
      getAllBrands({ params: { category: "handbags" } })
    }
  }, [])

  function _getSliderBanner() {
    const params = { params: { category: "handbags" } };

    setActiveSlide(0)

    setPause(true)

    sliderBanner(params);
  };

  function onClickBrand(url) {
    history.push(`/search/luxury/${url.toLowerCase()}`)
  }

  return (
    <Container fluid className="main-container" id="home-container" >
      <div className="d-none d-sm-block">
        <Banner
          src={getCloudImageUrl(sliderUrl, 1500)}
          alt="hot products banner"
          classNameBanner="luxury-brand-header"
        />
      </div>
      <div className="d-block d-sm-none">
        <Banner
          src={sliderUrl}
          alt="hot products banner"
        />
      </div>
      {
        brandData.length === 0? null
        :
        <div className="brands-section">
          <div className="brand-images">
            {
              brandData && brandData.map(item => {
                const imageLandscape = item.images && item.images.length > 0? item.images.filter(item => item.orientation === "landscape") : [];
                const displayingImage = imageLandscape.length > 1? imageLandscape[1] : (imageLandscape.length > 0? imageLandscape[0] : null)

                return <div onClick={() => onClickBrand(item.name)} className="brand-display">
                  {
                    displayingImage && displayingImage.URL ?
                      <KickImage key={item.id} style={{ width: "100%", height: "100%" }} src={getCloudImageUrl(displayingImage.URL, 600)} alt="" />
                      :
                      <h4 key={item.id} >{item.name}</h4>
                  }
                </div>
              })
            }
          </div>
        </div>
      }
    </Container>
  )
}

const mapStateToProps = state => ({
  brandData: state.filterReducer.brands
})

const mapDispatchToProps = dispatch => ({
  getAllBrands: (query) => dispatch(getAllBrands(query)),
  sliderBanner: payload => dispatch(sliderBanner(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LuxuryBrandPage))
